// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nli[draggable='true'][data-v-53070208] {\n\tcursor: move;\n}\nli[draggable='true'].hover[data-v-53070208] {\n\topacity: 0.4;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
